const formatRate = (text: number | string) => {
  if (text === 0) return text;
  if (text && typeof text == "number") {
    return (text * 100).toFixed(2);
  } else if (typeof text == "string" && text !== "")
    return (parseFloat(text) * 100).toFixed(2);
};

const formatNumber = (number: number) => {
  return number.toFixed(2);
};

const formatTextToNumber = (text: string) => {
  return Number.parseFloat(text).toFixed(2);
};

const trimText = (text: string) => {
  if (text) {
    if (text.length <= 15) return text;
    return text.slice(0, 15) + "...";
  }
  return text;
};

export { formatRate, formatNumber, formatTextToNumber, trimText };
